import * as React from "react";
import { Row, Col } from "antd";
import CartContext from "Context/CartContext";

export interface Props {
    children?: React.ReactNode
}

export interface State {
}

export default class CheckoutFooter extends React.Component<Props, State> {
    static contextType = CartContext;
    context!: React.ContextType<typeof CartContext>;

    constructor(props: Props) {
        super(props)
        this.renderTotalFooter = this.renderTotalFooter.bind(this);

        this.state = {
        }
    }

    renderTotalFooter() {

        if (!this.context ?.data ?.cartItems) {
            return <></>
        }

        return (
            <Row >
                <Col style={{ textAlign: "left", fontSize: "1.5em", borderBottom: "1px grey double" }} span={16}>Total: $JMD {this.context ?.data ?.total}</Col>
                <Col style={{ textAlign: "right", fontSize: "1.5em", borderBottom: "1px grey double" }} span={8}>Checkout</Col>
            </Row>
        )
    }

    render() {
        return (
            this.renderTotalFooter()
        )
    }
}
